import React from 'react';
import '../../../styles/modes/customMode.css';

const PathActions = ({ 
  confirmPath, 
  resetPath, 
  customPath, 
  locationsLength 
}) => {
  return (
    <div className="custom-path-actions">
      <button 
        className="primary-button"
        onClick={confirmPath}
        disabled={customPath.length < 2 || customPath.length < locationsLength}
      >
        Confirm Path
      </button>
      <button 
        className="reset-btn"
        onClick={resetPath}
        disabled={customPath.length === 0}
      >
        Reset Path
      </button>
    </div>
  );
};

export default PathActions; 